<!--
 * @Author: your name
 * @Date: 2021-10-29 14:53:28
 * @LastEditTime: 2021-11-01 16:45:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \dsicm-admin-web\src\views\decisionPage\leftModule\components\Collapse.vue
-->
<template>
  <div class="collapse">
    <!-- 大标题 -->
    <div class="message-item-box-title" v-if="titleType=='headline'" @click="open">
      <span class="message-item-box-name">{{titleName}}</span>
      <div class="message-item-box-text">
        <span class="name-icon">{{openFlag?"收起":"展开"}}</span>
        <span class="instructions_icon" :class="!openFlag?'down_icon':'up_icon'"></span>
      </div>
    </div>
    <!-- 小标题 -->
    <div class="message-title-box" :class="!openFlag?'border_bottom':''" v-if="titleType=='subheading'" @click="open">
      <span class="name-icon">{{titleName}}</span>
      <span class="instructions_icon" :class="!openFlag?'down_icon':'up_icon'"></span>
    </div>
    <div class="p_cont" ref="liCon">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titleType: {
      type: String,
      default: "headline" //大标题， subheading 小标题
    },
    titleName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      liConHeight: 0,
      openFlag: true
    };
  },
  methods: {
    open() {
      const liCon = this.$refs.liCon;
      var height = liCon.offsetHeight;
      if (height === this.liConHeight) {
        // 展开
        liCon.style.height = "auto";
        // height = liCon.offsetHeight;
        // liCon.style.height = this.liConHeight + "px";
        // var f = document.body.offsetHeight; // 必加
        // liCon.style.height = height + "px";
      } else {
        // 收缩
        liCon.style.height = height + "px";
        var f = document.body.offsetHeight;
        liCon.style.height = this.liConHeight + "px";
      }
      this.openFlag = !this.openFlag;
    }
  }
};
</script>

<style lang="less" scoped>
.p_cont {
  font-size: 14px;
  color: #555;
  overflow: hidden;
  transition: height 0.5s;
  margin-top: 10px;
}

.message-item-box-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
  padding: 10px 0 5px 0;
  cursor: pointer;
  .message-item-box-name {
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #1a7bfc;
    line-height: 17px;
  }

  .message-item-box-text {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .name-icon {
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #1a7bfc;
      line-height: 14px;
      margin: 0 5px 0 0;
    }

    .instructions_icon {
      width: 0px;
      height: 0px;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-bottom: 6px solid #1a7bfc;
    }

    .down_icon {
      transform: rotate(180deg);
      transition-delay: 0.35s;
      animation: mymove 1s;
    }
    .up_icon {
      transform: rotate(0deg);
      transition-delay: 0.35s;
      animation: mymove1 1s;
    }
    @keyframes mymove {
      from {
        transform: rotate(0deg);
      }

      to {
        transform: rotate(180deg);
      }
    }

    @-webkit-keyframes mymove

                /*Safari and Chrome*/ {
      from {
        transform: rotate(0deg);
      }

      to {
        transform: rotate(180deg);
      }
    }

    @keyframes mymove1 {
      from {
        transform: rotate(180deg);
      }

      to {
        transform: rotate(0deg);
      }
    }

    @-webkit-keyframes mymove1

                /*Safari and Chrome*/ {
      from {
        transform: rotate(180deg);
      }

      to {
        transform: rotate(0deg);
      }
    }
  }
}
.border_bottom{
 
  border-bottom: 1px solid #F0F0F0;
  padding-bottom: 10px;
  transition:   0.2s ease-out;
}
.message-title-box {
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  .name-icon {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 14px;
  }

  .instructions_icon {
    width: 0px;
    height: 0px;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-bottom: 6px solid #bfbfbf;
  }

  .down_icon {
    transform: rotate(180deg);
    transition-delay: 0.35s;
    animation: mymove 1s;
  }
  .up_icon {
    transform: rotate(0deg);
    transition-delay: 0.35s;
    animation: mymove1 1s;
  }
  @keyframes mymove {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(180deg);
    }
  }

  @-webkit-keyframes mymove

            /*Safari and Chrome*/ {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(180deg);
    }
  }
  @keyframes mymove1 {
    from {
      transform: rotate(180deg);
    }

    to {
      transform: rotate(0deg);
    }
  }

  @-webkit-keyframes mymove1

                /*Safari and Chrome*/ {
    from {
      transform: rotate(180deg);
    }

    to {
      transform: rotate(0deg);
    }
  }
}
</style>